var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"font-weight-this; overline",attrs:{"dense":"","inset":"","app":""}},[_c('v-col',{staticClass:"text-right",attrs:{"cols":"12"}},[_vm._v(" BrunoCF "+_vm._s(new Date().getFullYear())+" — "),_c('a',{attrs:{"href":"https://github.com/brunobcfum/homepage"}},[_vm._v("Fork me")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }